import React from 'react';

import PropTypes from 'prop-types';

import { SubTitle } from 'components/SubTitle/SubTitle';

export const RenderAemComponent = (props) => {
  const { name, componentProps } = props;
  const fieldsToNotRender = ['cqPath', 'componentProperties', 'isInEditor'];
  const renderData = (data) => {
    if (Array.isArray(data)) {
      return (
        <ul>
          {data.map((item, index) => (
            <li key={index}>{renderData(item)}</li>
          ))}
        </ul>
      );
    }
    if (typeof data === 'object' && data !== null) {
      return (
        <ul>
          {Object.entries(data).map(([key, value]) => {
            if (!fieldsToNotRender.includes(key)) {
              return (
                <li key={key}>
                  <strong>{key}:</strong> {renderData(value)}
                </li>
              );
            }
            return null;
          })}
        </ul>
      );
    }
    return <span>{String(data)}</span>;
  };

  return (
    <div className="input-field">
      <SubTitle text={name} />
      {renderData(componentProps)}
    </div>
  );
};

RenderAemComponent.propTypes = {
  name: PropTypes.string,
  componentProps: PropTypes.object,
};

RenderAemComponent.defaultProps = {
  name: '',
  componentProps: {},
};
